import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import {
  Container,
  Dot,
  OuterFrame,
  HeartIcon,
  InnerContainer,
  Info,
  Acreage,
} from './LandItFrame.styled';

class LandItFrame extends React.Component {
  constructor() {
    super();

    this.state = {
      isVisible: false,
    };

    this.visibilityChange = this.visibilityChange.bind(this);
  }

  visibilityChange(isVisible) {
    this.setState({
      isVisible: isVisible,
    });
  }

  render() {
    return (
      <VisibilitySensor
        onChange={this.visibilityChange}
        active={!this.state.isVisible}
      >
        <Container>
          <OuterFrame visible={this.state.isVisible ? true : false}>
            <HeartIcon visible={this.state.isVisible ? true : false} />
            <InnerContainer>
              <Info>
                <li>$25,000</li>
                <li>8616 Happy Home Drive</li>
                <li>Knoxville, TN 37901</li>
              </Info>
              <Acreage>0.85 Acres</Acreage>
            </InnerContainer>
          </OuterFrame>
          <Dot visible={this.state.isVisible ? true : false} />
        </Container>
      </VisibilitySensor>
    );
  }
}

export default LandItFrame;
